<div class="container">
  <button mat-icon-button="" class="close-btn" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="header">
    <mat-icon class="title-icon">celebration</mat-icon>
    <h5 class="title" >{{'Success' | translate}}</h5>
  </div>
  <p class="text" >{{'Changesavedsuccessfully' | translate}}</p>
  <button class="btn-close" (click)="dialogRef.close()">{{"Close" | translate}}</button>
</div>
